window.isInIframe = function () {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

document.body.className += isInIframe() ? " in-iframe" : " not-in-iframe"


// WEBPACK FOOTER //
// ./app/webpack/shared/config/isInIframe.js